import React, { useState } from "react";
import Layout from "../form-layout";
import { GLP1_MEDICATIONS } from "../../data/eligibility-rules";

// Q13 — "Have you ever taken any of the following medications to help you lose
// weight?" Kept as its own question per the docs, even though for Form B patients
// this overlaps with what they already told us at the start of Form B.
export default function Step13({ formData, onBack, goToStep, setFormData }) {
  const [selected, setSelected] = useState(formData.glp1TriedMedication || "");

  const handleSelect = (key) => {
    setSelected(key);
    setFormData((prev) => ({ ...prev, glp1TriedMedication: key }));
    localStorage.setItem("glp1TriedMedication", key);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!selected) return;

    if (selected === "none") {
      goToStep(formData.biologicalSex === "Female" ? "pregnancyGate" : "additionalInfo");
    } else {
      goToStep("14");
    }
  };

  return (
    <Layout goToStep={goToStep} onBack={onBack}>
      <h2 className="text-sm sm:text-[14px] font-medium text-[#000000] mb-6">
        Have you ever taken any of the following medications to help you lose weight?
      </h2>

      <form onSubmit={handleSubmit} className="flex flex-col gap-3">
        {GLP1_MEDICATIONS.map((med) => (
          <label key={med.key} className="flex items-center gap-2 p-3 rounded-lg cursor-pointer border transition-all text-sm">
            <input
              type="radio"
              name="glp1TriedMedication"
              checked={selected === med.key}
              onChange={() => handleSelect(med.key)}
              className="h-4 w-4 accent-sky-400 cursor-pointer"
            />
            <span>{med.label}</span>
          </label>
        ))}

        <div className="flex justify-start mt-4">
          <button
            type="submit"
            disabled={!selected}
            className={`w-[210px] text-sm font-semibold rounded-lg py-3 transition-colors
              ${!selected ? "bg-gray-300 text-gray-600 cursor-not-allowed" : "bg-[#35C3D9] text-white hover:bg-[#27AAC0]"}`}
          >
            Next →
          </button>
        </div>
      </form>
    </Layout>
  );
}
